<template>
    <div class="main-wrapper">
        <div class="main mb80">
            <div class="main-inner">
                <div class="page-title">
                    <div class="container">
                        <h1>{{ title }}</h1>
                        <div class="page-title-actions" v-if="!this.$store.getters.jail">
                            <language-selector></language-selector>
                            <slot name="pageTitleActions"></slot>
                        </div>
                    </div>
                </div>
                <div class="container" v-if="!full">
                    <breadcrumb v-if="!this.$store.getters.jail" :breadcrumb="breadcrumb" :current="title"></breadcrumb>
                    <slot></slot>
                </div>
                <div class="container-fluid" v-else>
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from './Breadcrumb'
import LanguageSelector from './LanguageSelector'

export default {
  name: 'Page',
  props: {
    title: {
      description: 'Page title property',
      required: true,
      type: String,
    },
    breadcrumb: {
      description: 'Array of objects with name and path property.',
      required: false,
      type: Array,
    },
    full: {
      description: 'Full page width',
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data () {
    return {
      message: null,
    }
  },
  components: {Breadcrumb, LanguageSelector},
  watch: {
    title: (to) => {
      document.title = to + ' | Camp Site'
    },
  },
  mounted () {
    document.title = this.title + ' | Camp Site'
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/Page.vue